var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.99 19.5996C19.285 11.8956 14.264 9.04862 14.264 9.04862C14.264 6.89262 15.858 5.46562 16.895 4.76562C17.379 4.43862 17.537 3.78862 17.278 3.25662L16.99 2.66462C16.753 2.17862 16.221 1.90062 15.708 2.03362C14.479 2.35262 13.369 3.11162 12.691 3.65462C12.283 3.98162 11.718 3.98162 11.309 3.65462C10.63 3.11162 9.52001 2.35262 8.29201 2.03362C7.77901 1.89962 7.24701 2.17762 7.01001 2.66462L6.72201 3.25662C6.46301 3.78862 6.62201 4.43962 7.10501 4.76562C8.14201 5.46562 9.73601 6.89262 9.73601 9.04862C9.73601 9.04862 4.71401 11.8956 4.01001 19.5996C3.84501 21.4006 5.83801 22.5366 7.20001 21.3916L7.22501 21.3706C8.06201 20.6676 9.50101 20.5816 10.291 21.3416C11.195 22.2116 12.772 22.2186 13.687 21.3636C14.5 20.6046 15.951 20.6766 16.801 21.3916V21.3916C18.162 22.5376 20.155 21.4016 19.99 19.5996V19.5996Z",
    stroke: "",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74001 9.0498H14.26",
    stroke: "",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDress);
export default __webpack_public_path__ + "static/media/dress.60a61f43.svg";
export { ForwardRef as ReactComponent };